import { render, staticRenderFns } from "./adminAccDialog.vue?vue&type=template&id=cb993096&scoped=true&"
import script from "./adminAccDialog.vue?vue&type=script&lang=js&"
export * from "./adminAccDialog.vue?vue&type=script&lang=js&"
import style0 from "./adminAccDialog.vue?vue&type=style&index=0&id=cb993096&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb993096",
  null
  
)

export default component.exports